export default __webpack_public_path__ + "static/media/crs15.8c16cd6b.jpg";